export const Constants = {
  STORAGE_VARIABLES: {
    TOKEN: '__TK__',
    USER: '__USK__',
    TENANT: '__TNK__',
    USER_TYPE: '__UST__',
    TENANT_USER_TYPE: '__TUST__',
    PREFERRED_LANGUAGE: '__LANGUAGE__',
    NOTIFICATION: '__NOTIFICATION__',
    CLICKED_ITEMS: '__CLI__',
    LOCATION: '__LOCATION__',
    HOTJAR: '__HJ__',
    GOOGLE: '__GIS__',
    CLIENT: '__CL__',
    ONBOARDING: '__ONB__',
    REFERRAL: '__REF__',
  },

  SSO_QUERY_KEY: 'sso',
  COUNTRIES: [
    {
      name: 'Nigeria',
      code: 'NG',
      phoneCode: '+234',
      currency: 'NGN',
    },
  ],
  DEFAULT_CURRENCY_NGN: 'NGN',
  ERROR_500: 'error500',
  ERROR_503: 'error503',
  ACCEPTED_FILE_UPLOAD_FORMATS: ['png', 'jpg', 'jpeg'],

  PAGINATION: {
    PREVIOUS_PAGE: 'previous',
    NEXT_PAGE: 'next',
    DEFAULT_PAGE_SIZE: 10,
  },

  TAX: {
    NAME_SUGGESTIONS: ['Value-added Tax (VAT)', 'Consumption Tax'],
  },
  LANGUAGES: [],
  MAXIMUM_RATING: 5,
  SUCCESS: 'success',
  APP_NAME: 'ComplyDesk',
  FORM_VALIDATION_MESSAGES: {
    required: 'This field is required.',
    email: 'Please enter a valid email address.',
    emailAlreadyExist: 'Email Already Exist.',
    minlength: 'The entered value is too short.',
    maxlength: 'The entered value is too long.',
    pattern: 'The entered value does not match the required pattern.',
  },
  CONTACT_US: {
    SUPPORT_EMAIL: 'support@complydeskng.com',
    SUPPORT_NUMBER: '+2348029694961',
    SUPPORT_ADDRESS: '2, Tokunbo Alli Street Off Toyin Street, Ikeja',
  },
  RESET_TIMER_MIN: 5,
  TENANT_CODE_A: 'COMPLYDESKA1',
  TENANT_CODE_B: 'COMPLYDESKB1',
  BANK_DETAILS: {
    BANK_NAME: 'Fidelity Bank',
    ACCOUNT_NUMBER: '4210099840',
    ACCOUNT_NAME: 'ComplyDesk Limited',
  },
  BANK_DETAILS_2: {
    BANK_NAME: 'Fidelity Bank',
    ACCOUNT_NUMBER: '4210099888',
    ACCOUNT_NAME: 'ComplyDesk Limited',
  },
  DEMO_VIDEO_URL: 'https://embed.app.guidde.com/playbooks/cp3cCMpfb9aN8nWePiVsYz?mode=videoOnly',
};
